import { util } from 'api';
export const systemIsMac = () => {
    try {
        return /mac os x/i.test(navigator.userAgent);
    }
    catch (e) {
        console.error('[Error systemIsWindow]', e);
    }
};
const separator = ' ';
export const formatHotKey2SettingPage = (hotKey) => {
    if (hotKey) {
        const commandStr = util.getCommonTxt();
        const showKey = {
            command: commandStr,
            shift: systemIsMac() ? '⇧' : 'Shift',
            alt: systemIsMac() ? '⌥' : 'Alt',
            ctrl: systemIsMac() ? '⌃' : 'Ctrl',
            enter: systemIsMac() ? '↩' : 'Enter',
            up: '↑',
            down: '↓',
            del: '⌫',
        };
        if (typeof hotKey === 'string') {
            const res = showKey[hotKey.toLowerCase()] || hotKey;
            return res;
        }
        if (Array.isArray(hotKey)) {
            if (hotKey.every(item => typeof item === 'string')) {
                return hotKey
                    .map(item => {
                    const hkStr = item;
                    return showKey[hkStr.toLowerCase()] || hkStr.toUpperCase();
                })
                    .join(separator);
            }
            if (hotKey.every(item => Array.isArray(item))) {
                return hotKey
                    .map(item => {
                    const hkStrList = item;
                    return hkStrList.map(hkStr => showKey[hkStr.toLowerCase()] || hkStr.toUpperCase()).join(separator);
                })
                    .join(' | ');
            }
            console.error('快捷键配置错误, 快捷键配置必须为字符串或者字符串数组，不能混合');
            return '';
        }
    }
    return '';
};
export const formatHotKey2Lib = (hotKey) => {
    if (hotKey) {
        if (typeof hotKey === 'string') {
            return hotKey.toLowerCase();
        }
        if (Array.isArray(hotKey)) {
            if (hotKey.every(item => typeof item === 'string')) {
                return hotKey.map(item => item.toLowerCase()).join('+');
            }
            if (hotKey.every(item => Array.isArray(item))) {
                return hotKey.map(item => item.map(hkStr => hkStr.toLowerCase()).join('+'));
            }
            console.error('快捷键配置错误, 快捷键配置必须为字符串或者字符串数组，不能混合');
            return '';
        }
    }
    return '';
};
export const formatHotKey2LibString = (hotKey) => {
    if (hotKey) {
        const res = formatHotKey2Lib(hotKey);
        if (typeof res === 'string') {
            return res;
        }
        if (Array.isArray(res)) {
            return res[0];
        }
    }
    return '';
};
